// src/features/tasks/services/taskManuals.js
import { apiClient } from '../../../services/api/client';

export const taskManualsAPI = {
  // List manuals linked to a task
  listTaskManuals: (taskId) =>
    apiClient.get(`/api/v1/task-management/tasks/${taskId}/manuals`),

  // Link manual to a task
  linkManualToTask: (taskId, data) =>
    apiClient.post(`/api/v1/task-management/tasks/${taskId}/manuals`, data),

  // Unlink manual from a task
  unlinkManualFromTask: (taskId, taskManualId) =>
    apiClient.delete(`/api/v1/task-management/tasks/${taskId}/manuals/${taskManualId}`),
};
